/** @format */
'use client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled, { keyframes } from 'styled-components';

interface LoadingSpinnerProps {
  height?: string;
  width?: string;
}

const spin = keyframes`
0%{
  transform: rotate(0deg);
}
  
  100%{
    transform: rotate(360deg);
  }
`;

const StyledLoadingSpinner = styled.div<{ height?: string; width?: string }>`
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center;
  > svg {
    animation: ${spin} 2s linear infinite;
  }
`;

function LoadingSpinner(props: LoadingSpinnerProps) {
  return (
    <StyledLoadingSpinner {...props}>
      <FontAwesomeIcon icon={['fas', 'spinner']} color={'#40a9ff'} height={props.height} width={props.width} />
    </StyledLoadingSpinner>
  );
}

export default LoadingSpinner;
